<template>
  <div>
    <v-switch
      class="disable-label-click"
      v-bind="{ ...$attrs, ...$props }"
      :model-value="modelValue"
      @update:model-value="emitChange"
      color="secondary"
      hide-details="auto"
      density="compact">
      <template v-slot:label>
        <div :class="{ 'text--disabled': !modelValue }">
          <div class="d-flex justify-center align-center pl-1">
            <span class="d-block mr-2">
              {{
                $t(
                  'forms.elements.switches.carrierSchedulingToggle.labels.entityAvailableOnSchedulingPortal',
                  { entity: translatedEntity }
                )
              }}
            </span>
            <help-icon-tooltip iconStyleClass="grey darken-2">
              {{ toggleMessage }}
            </help-icon-tooltip>
          </div>
        </div>
      </template>
    </v-switch>

    <p class="pt-2" v-if="shouldDisplayDisclaimer">
      {{
        $t(
          'forms.elements.switches.carrierSchedulingToggle.messages.thisWillMakeEntityAvailableOnSchedulingPortal',
          { entity: translatedEntity }
        )
      }}.
      <template
        v-if="
          entity === DatabaseEntities.Warehouse || entity === $t('global.specialtyTerms.warehouses')
        ">
        {{
          $t(
            'forms.elements.switches.carrierSchedulingToggle.messages.thisWillMakeEntityAvailableOnSchedulingPortal',
            { entity: translatedEntity }
          )
        }}.
      </template>
    </p>
  </div>
</template>

<script>
import config from '@/config/config';
import { DatabaseEntities } from '@nova/core';
import { camelCase } from 'lodash';

/**
 * Carrier Scheduling Toggle
 * @displayName Carrier Scheduling Toggle
 */
export default {
  name: 'CarrierSchedulingToggle',
  data() {
    return { DatabaseEntities };
  },
  props: {
    /**
     * @model
     */
    modelValue: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Name of entity flag is toggled on
     */
    entity: {
      type: String,
      required: true,
      validator(value) {
        // The value must match one of these strings
        return ['Warehouse', 'Dock', 'Load Type'].includes(value);
      }
    },
    shouldDisplayDisclaimer: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    translatedEntity() {
      return this.$t(`global.specialtyTerms.${camelCase(this.entity.toLowerCase())}s`);
    },
    carrierSchedulingRequestMail() {
      const emailAddress = 'support@opendock.com';
      const subject = `Nova Request - Import Org in ODC Admin - Org ${this.$org.name}`;
      const body = `Please import/enable this Org in ODC Admin (Opendock Scheduling Portal): ${this.$org.name} - ${this.$org.id}.  Environment: ${config.node_env}`;
      return encodeURI(`mailto:${emailAddress}?subject=${subject}&body=${body}`);
    },
    toggleMessage() {
      return {
        Warehouse: this.$t(
          'warehouse.pages.settings.messages.enableCarrierSchedulingForThisWarehouseLocation'
        ),
        Dock: this.$t('warehouse.pages.settings.messages.enableCarrierSchedulingForThisDock'),
        'Load Type': this.$t(
          'warehouse.pages.settings.messages.enableCarrierSchedulingForThisLoadTypeAcrossAllLocations'
        )
      }[this.entity];
    }
  },
  methods: {
    /**
     * @model
     * @param value
     */
    emitChange(value) {
      this.$emit('input', value ?? false);
    },
    /**
     * Adds event listeners to prevent label from toggling switch
     */
    addEventListeners() {
      document.querySelectorAll('.disable-label-click').forEach(element => {
        element.querySelector('label').addEventListener('click', clickHandler);
      });

      // Using named function here allows the browser to discard exact duplicate event listeners automatically
      function clickHandler(e) {
        e.stopPropagation();
      }
    }
  },
  mounted() {
    this.addEventListeners();
  }
};
</script>
